"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _guid = _interopRequireDefault(require("../../utils/helpers/guid"));

var _browser = _interopRequireDefault(require("../../utils/helpers/browser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Portal = ({
  children,
  className,
  id,
  onReposition
}) => {
  const [portalNode, setPortalNode] = (0, _react.useState)(null);
  const uniqueId = (0, _react.useMemo)(() => (0, _guid.default)(), []);
  (0, _react.useEffect)(() => {
    if (onReposition) {
      onReposition();
      window.addEventListener("resize", onReposition);
    }

    return () => {
      if (onReposition) {
        window.removeEventListener("resize", onReposition);
      }
    };
  }, [onReposition]);
  (0, _react.useEffect)(() => {
    return () => {
      portalNode.remove();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addClassNames = node => {
    className.split(" ").forEach(el => {
      node.classList.add(el);
    });
    return node;
  };

  const getPortalContainer = () => {
    const portalClassName = "carbon-portal";
    let node = portalNode;

    if (!node && id !== undefined && document.getElementById(id)) {
      node = document.getElementById(id);
      setPortalNode(node);
    } else if (!node) {
      node = document.createElement("div");
      node.classList.add(portalClassName);
      node.setAttribute("data-portal-exit", uniqueId);

      if (id !== undefined) {
        node.setAttribute("id", id);
      }

      setPortalNode(node);
      const rootDiv = document.getElementById("root"); // Storybook adds the hidden attribute to the root element when on the "Docs" pages
      // Without this check the portal would also be hidden

      if (rootDiv && !rootDiv.hasAttribute("hidden")) {
        rootDiv.appendChild(node);
      } else {
        document.body.appendChild(node);
      }
    }

    if (className) {
      node = addClassNames(node);
    }

    return node;
  };

  if (!_browser.default.isDomAvailable()) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("span", {
    "data-portal-entrance": uniqueId
  }, /*#__PURE__*/_reactDom.default.createPortal(children, getPortalContainer()));
};

Portal.propTypes = {
  /** The content of the portal. */
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  id: _propTypes.default.string,

  /** Callback function triggered when parent element is scrolled or window resized. */
  onReposition: _propTypes.default.func
};
var _default = Portal;
exports.default = _default;